import * as React from 'react';
import { TColors } from '@cian/ui-kit/colors';
import { IconMetroMsk16, IconMetroSpb16 } from '@cian/ui-kit/icons';
import * as styles from './UndergroundIcon.css';
import { isSpbOrLO } from '../../utils/isSpbOrLO';
import { isMoscowOrMO } from '../../utils/isMoscowOrMO';

interface IUndergroundIconProps {
  regionId: number | null;
  lineColor: string;
}

export function UndergroundIcon({ regionId, lineColor }: IUndergroundIconProps) {
  if (regionId) {
    let Icon;

    if (isMoscowOrMO(regionId)) {
      Icon = IconMetroMsk16;
    }

    if (isSpbOrLO(regionId)) {
      Icon = IconMetroSpb16;
    }

    if (Icon) {
      return (
        <div className={styles['underground-icon']} style={{ color: `#${lineColor}` }}>
          <Icon color={'currentColor' as TColors} />
        </div>
      );
    }
  }

  return <div className={styles['underground-icon--regions']} style={{ color: `#${lineColor}` }} />;
}
